exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Site module should live here.\n * Import as neede like so:\n * ...\n * import siteStyles from 'siteModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"site-item\">\n * ...\n */\n\n.modules-site-___siteModuleStyles__site-item___2-v0J {\n\n}\n", ""]);

// exports
exports.locals = {
	"site-item": "modules-site-___siteModuleStyles__site-item___2-v0J"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/site/siteModuleStyles.css
// module id = 1358
// module chunks = 1